import _get from 'lodash/get';
import _set from 'lodash/set';
import _merge from 'lodash/merge';
import { get as cookiesGet } from 'bam-cookies/dist/browser_browser_es5/main';
import pageMeta from 'pageMeta/pageMeta';
import {
    getMetadataURL,
} from '../utils/forge-utils';


/**
 *
 * @desc MediaItem
 *
 */
class MediaItem {

    constructor(data, mediaConfig, requestParams) {

        this.requestParams = requestParams;

        this.parseData(data, mediaConfig);

    }

    parseData(data, mediaConfig) {

        const playbackScenario = this.getPlayBackScenario(_get(data, 'playbacks', []), _get(data, 'mediaState') === 'MEDIA_ON', mediaConfig);

        // Try to get the bigger poster size available
        const PREFERRED_POSTER_SIZE = [
            1024,
            960,
        ];

        const THUMBNAIL_IMAGE_SIZE = 372;
        const cuts = _get(data, 'image.cuts', []);
        const closedCaptions = _get(data, 'closedCaptions');

        this.title = _get(data, 'title');
        this.contentId = _get(data, 'contentId') || _get(data, 'content_id') || _get(data, 'id');
        this.description = _get(data, 'description');
        this.duration = _get(data, 'duration');
        this.tags = {};
        this.src = _get(playbackScenario, 'url');
        this.image = this.getImage(cuts, THUMBNAIL_IMAGE_SIZE);
        this.poster = this.getPoster(cuts, PREFERRED_POSTER_SIZE);
        this.data = data;
        this.adConfig = this.getAdConfig(data);
        this.vttItems = closedCaptions ? [
            {
                label: 'English',
                src: closedCaptions,
                srclang: 'en',
                default: true,
            },
        ] : [];

    }

    /**
     *
     * @desc Get the playback scenario.
     * @param {array} playbacks     List of playback scenarios
     * @param {boolean} isLive      Specify if live or vod
     * @param {object} mediaConfig  The apps mediaConfig
     * @returns {object} the playback scenario or an empty object
     */
    getPlayBackScenario(playbacks, isLive, mediaConfig) {

        let hlsPlaybackList;
        let mp4PlaybackList;
        let playbackSearchList;

        if(isLive) {

            playbackSearchList = _get(mediaConfig, 'global.livePlaybackScenarios');

        } else {

            playbackSearchList = _get(mediaConfig, 'global.preferredPlaybackScenarios');

            // HLS Playbacks
            hlsPlaybackList = playbackSearchList.filter((playbackName) => playbackName.indexOf('mp4') < 0 && playbackName.indexOf('FLASH') < 0);

            // MP4 Playbacks
            mp4PlaybackList = playbackSearchList.filter((playbackName) => playbackName.indexOf('mp4') > -1 || playbackName.indexOf('FLASH') > -1);

            // Set playback search list
            playbackSearchList = hlsPlaybackList.concat(mp4PlaybackList);

        }

        // Prioritized Playbacks
        let prioritizedPlaybacks = [];

        // Prioritize array of playback objects based on Playback Search List
        playbackSearchList.forEach(function(playbackName) {

            let filteredPlayback = playbacks.filter((playback) => playback.name === playbackName)[0];
            if(filteredPlayback) {

                prioritizedPlaybacks.push(filteredPlayback);

            }

        });

        // Return highest priority playback or an empty object
        return prioritizedPlaybacks[0] || {};

    }

    getImage(cuts, width) {

        return cuts
            .filter((img) => img.aspectRatio==='16:9')
            .sort((a, b) => a.width < b.width ? -1 : 1)
            .find((img) => img.width >= width);

    }

    getPoster(cuts, widthSizes) {

        if (typeof widthSizes === 'object' && widthSizes.length > 0) {

            let imagesObject;
            widthSizes
                .find((width) => {

                    const currentImagesObject = this.getImage(cuts, width);

                    if (currentImagesObject !== undefined) {

                        imagesObject = currentImagesObject;
                        return true;

                    };

                    return false;

                });
            return imagesObject;

        }

    }

    getMetadata(mediaConfig) {

        const cmsDataURL = getMetadataURL(this.data.slug);

        return fetch(cmsDataURL)
            .then((res) => res.json())
            .then((metadata) => {

                this.parseData(metadata, mediaConfig);

            });

    }

    /**
     *
     * @desc Creates the adConfig object using the clip data and attatches to the clip
     * @return object clip with adConfig
     *
     */

    getAdConfig(data) {

        //based con COREMED-237 vid should be a param and also sent on the cust_params object
        const env = pageMeta['env'];

        let custParams = {
            vid: _get(data, 'id'),
            aam_uuid: cookiesGet('aam_uuid') || '',
            env,
        };

        let custParamsQuery = _get(this.requestParams, 'query.cust_params');
        let custParamsJSON = {};

        if (custParamsQuery) {

            try {

                custParamsJSON = JSON.parse(custParamsQuery);

            } catch(e) {

                console.debug('WARNING: There was an issue parsing "cust_params". "cust_params" should be URL encoded JSON.', e);

            }

        }

        custParams = _merge({}, custParams, custParamsJSON);

        const adConfig = {
            vid: _get(data, 'id'),
            cust_params: custParams,
        };

        return adConfig;

    }


}

export default MediaItem;
